import { boot } from 'quasar/wrappers'
import activityType from '../functions/activity-type'

export default boot(({ app }) => {
	app.config.globalProperties.$activityType = activityType
})
